/* ============================================================
   DarthDabs — Slot Machine state machine.
   Flow: idle (form) → spinning (reels animate) → revealed (codes shown)
   Cooldown: 14 days via localStorage.dd_slot_last_pull (timestamp ms).

   Visibility (Bob, 2026-07-01): homepage only (gated in layout/theme.liquid)
   and each visitor sees the tab ONCE, ever — localStorage.dd_slot_seen.
   Leaving the page and coming back must not bring it back.

   Submission: fire-and-forget POST to /contact (form_type=customer,
   accepts_marketing=1) so the spin starts instantly. No third party.
   ============================================================ */
(function () {
  'use strict';

  var STORAGE_KEY = 'dd_slot_last_pull';
  var SEEN_KEY = 'dd_slot_seen';
  var COOLDOWN_MS = 14 * 24 * 60 * 60 * 1000;
  var SYMBOL_REPEATS = 24;        // strip length for visible spin loop
  var SYMBOL_HEIGHT = 90;         // matches reel height in CSS
  var SYMBOLS = ['dd', 'leaf', 'bong', 'flame'];

  // Outcome table — exactly the 60/30/8/2 distribution from the brief.
  var OUTCOMES = [
    { id: 'common',  weight: 60, headline: '10% OFF YOUR ORDER',           codes: ['SPIN10'],          symbol: 'leaf'  },
    { id: 'combo',   weight: 30, headline: '10% OFF + FREE SHIPPING',      codes: ['SPIN10','SPINSHIP'], symbol: 'bong' },
    { id: 'rare',    weight: 8,  headline: '15% OFF YOUR ORDER',           codes: ['SPIN15'],          symbol: 'flame' },
    { id: 'jackpot', weight: 2,  headline: 'JACKPOT — 20% OFF',            codes: ['SPIN20'],          symbol: 'dd'    }
  ];

  // ---------- Init ----------
  var root  = document.querySelector('[data-dd-slot]');
  if (!root) return;

  // ---------- Once-per-visitor gate ----------
  // Already seen it? Remove it and stop. Otherwise mark it seen right now so
  // the next page load (or return visit) never shows it again.
  try {
    if (localStorage.getItem(SEEN_KEY) === '1') {
      if (root.parentNode) root.parentNode.removeChild(root);
      return;
    }
    localStorage.setItem(SEEN_KEY, '1');
  } catch (e) { /* storage blocked — fall through and show this load only */ }

  var toggleBtn  = root.querySelector('[data-dd-slot-toggle]');
  var panel      = root.querySelector('[data-dd-slot-panel]');
  var closeBtn   = root.querySelector('[data-dd-slot-close]');
  var form       = root.querySelector('[data-dd-slot-form]');
  var emailInput = root.querySelector('[data-dd-slot-email]');
  var consent    = root.querySelector('[data-dd-slot-consent]');
  var pullBtn    = root.querySelector('[data-dd-slot-pull]');
  var reelsEl    = root.querySelector('[data-dd-slot-reels]');
  var reels      = root.querySelectorAll('[data-dd-reel]');
  var coinsHost  = root.querySelector('[data-dd-slot-coins]');

  var states = {
    idle:     root.querySelector('[data-dd-slot-state="idle"]'),
    spinning: root.querySelector('[data-dd-slot-state="spinning"]'),
    revealed: root.querySelector('[data-dd-slot-state="revealed"]'),
    cooldown: root.querySelector('[data-dd-slot-state="cooldown"]')
  };

  var resultEl    = root.querySelector('[data-dd-slot-result]');
  var codesEl     = root.querySelector('[data-dd-slot-codes]');
  var sentEl      = root.querySelector('[data-dd-slot-sent]');
  var cooldownDateEl = root.querySelector('[data-dd-slot-cooldown-date]');

  var prefersReducedMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---------- Symbol SVG markup (must match dd-slot-symbol.liquid) ----------
  var SYMBOL_SVGS = {
    dd:    '<svg class="dd-slot__sym" viewBox="0 0 56 56" fill="none"><text x="28" y="40" text-anchor="middle" fill="currentColor" font-family="Cinzel, serif" font-size="28" font-weight="700" letter-spacing="-2">DD</text></svg>',
    leaf:  '<svg class="dd-slot__sym" viewBox="0 0 56 56" fill="currentColor"><path d="M28 52 L28 36 M28 36 C24 36 18 33 12 26 C16 27 22 28 24 30 C20 26 14 18 10 8 C16 12 22 18 25 24 C22 16 19 8 18 2 C22 8 26 16 27 22 C27 14 27 6 28 2 C29 6 29 14 29 22 C30 16 34 8 38 2 C37 8 34 16 31 24 C34 18 40 12 46 8 C42 18 36 26 32 30 C34 28 40 27 44 26 C38 33 32 36 28 36 Z" stroke="currentColor" stroke-width="0.8" stroke-linejoin="round"/></svg>',
    bong:  '<svg class="dd-slot__sym" viewBox="0 0 56 56" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linejoin="round" stroke-linecap="round"><path d="M22 8 L22 26 L14 38 C12 42 14 48 22 50 L34 50 C42 48 44 42 42 38 L34 26 L34 8 Z"/><line x1="22" y1="14" x2="34" y2="14"/><path d="M34 22 L46 30 L42 34" stroke-width="2"/></svg>',
    flame: '<svg class="dd-slot__sym" viewBox="0 0 56 56" fill="currentColor"><path d="M28 4 C20 14 16 22 16 30 C16 39 21 48 28 50 C35 48 40 39 40 30 C40 26 38 22 35 18 C34 22 32 24 30 24 C30 18 30 12 28 4 Z" stroke="currentColor" stroke-width="0.8" stroke-linejoin="round"/></svg>'
  };

  // ---------- State helpers ----------
  function setState(name) {
    Object.keys(states).forEach(function (k) {
      var el = states[k];
      if (!el) return;
      if (k === name) el.removeAttribute('hidden');
      else            el.setAttribute('hidden', '');
    });
    root.classList.toggle('is-spinning', name === 'spinning');
    root.classList.toggle('is-revealed', name === 'revealed');
    root.classList.toggle('is-cooldown', name === 'cooldown');
    if (name !== 'spinning') root.classList.remove('is-pulled');
  }

  function open() {
    panel.removeAttribute('hidden');
    // Force reflow so the transition fires from the translated state.
    // eslint-disable-next-line no-unused-expressions
    panel.offsetWidth;
    root.classList.add('is-open');
    toggleBtn.setAttribute('aria-expanded', 'true');

    if (isInCooldown()) {
      showCooldown();
    } else {
      setState('idle');
      validateForm();
      setTimeout(function () { try { emailInput.focus(); } catch (e) {} }, 380);
    }
  }
  function close() {
    root.classList.remove('is-open');
    toggleBtn.setAttribute('aria-expanded', 'false');
    setTimeout(function () { panel.setAttribute('hidden', ''); }, 380);
  }

  // ---------- Cooldown ----------
  function isInCooldown() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      var t = parseInt(raw, 10);
      if (!t || isNaN(t)) return false;
      return (Date.now() - t) < COOLDOWN_MS;
    } catch (e) { return false; }
  }
  function cooldownEndDate() {
    var raw = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
    return new Date(raw + COOLDOWN_MS);
  }
  function formatDate(d) {
    try {
      return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
    } catch (e) {
      return d.toDateString();
    }
  }
  function showCooldown() {
    if (cooldownDateEl) cooldownDateEl.textContent = formatDate(cooldownEndDate());
    setState('cooldown');
  }

  // ---------- Form validation ----------
  var EMAIL_RE = /^\S+@\S+\.\S+$/;
  function validateForm() {
    var ok = EMAIL_RE.test((emailInput.value || '').trim()) && consent.checked;
    pullBtn.disabled = !ok;
    return ok;
  }

  // ---------- RNG ----------
  function pickOutcome() {
    var total = 0;
    for (var i = 0; i < OUTCOMES.length; i++) total += OUTCOMES[i].weight;
    var r = Math.random() * total;
    for (var j = 0; j < OUTCOMES.length; j++) {
      r -= OUTCOMES[j].weight;
      if (r < 0) return OUTCOMES[j];
    }
    return OUTCOMES[0];
  }

  // ---------- Reel rendering ----------
  function buildStrip(finalSymbol) {
    // Repeated random symbols, with the final symbol parked at the bottom.
    // Reel translates by -(SYMBOL_REPEATS) * SYMBOL_HEIGHT to land on it.
    var html = '';
    for (var i = 0; i < SYMBOL_REPEATS; i++) {
      var s = SYMBOLS[Math.floor(Math.random() * SYMBOLS.length)];
      html += SYMBOL_SVGS[s];
    }
    html += SYMBOL_SVGS[finalSymbol];
    return html;
  }

  function resetReels(finalSymbol) {
    reels.forEach(function (reel) {
      var strip = reel.querySelector('[data-dd-strip]');
      strip.innerHTML = buildStrip(finalSymbol);
      strip.style.transition = 'none';
      strip.style.transform = 'translateY(0)';
      reel.classList.remove('is-locked');
    });
  }

  function landReel(reel, delay) {
    setTimeout(function () {
      var strip = reel.querySelector('[data-dd-strip]');
      strip.style.transition = prefersReducedMotion
        ? 'transform 150ms ease-out'
        : 'transform 420ms cubic-bezier(0.2, 1.2, 0.5, 1)';
      strip.style.transform = 'translateY(' + (-(SYMBOL_REPEATS) * SYMBOL_HEIGHT) + 'px)';
      reel.classList.add('is-locked');
    }, delay);
  }

  // ---------- Coin shower ----------
  function fireCoinShower() {
    if (prefersReducedMotion) return;
    var count = 24;
    var panelW = panel.clientWidth;
    var frag = document.createDocumentFragment();
    for (var i = 0; i < count; i++) {
      var c = document.createElement('div');
      c.className = 'dd-slot__coin';
      c.style.left = (Math.random() * (panelW - 22)) + 'px';
      c.style.animationDelay = (Math.random() * 0.6) + 's';
      c.style.animationDuration = (1.2 + Math.random() * 0.6) + 's';
      c.textContent = Math.random() < 0.5 ? '$' : 'DD';
      frag.appendChild(c);
    }
    coinsHost.appendChild(frag);
    setTimeout(function () { coinsHost.innerHTML = ''; }, 2000);
  }

  // ---------- Submit + reveal ----------
  function submitToShopify(email) {
    // Native Shopify customer signup. Fire-and-forget so the spin starts now.
    try {
      var fd = new FormData();
      fd.append('form_type', 'customer');
      fd.append('utf8', '✓');
      fd.append('contact[email]', email);
      fd.append('contact[accepts_marketing]', '1');
      fd.append('contact[tags]', 'newsletter,slot-machine');
      fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' })
        .catch(function () { /* swallow — spin already in flight */ });
    } catch (e) { /* no-op */ }
  }

  function reveal(outcome, email) {
    resultEl.textContent = outcome.headline;
    resultEl.classList.toggle('is-jackpot', outcome.id === 'jackpot');

    codesEl.innerHTML = '';
    outcome.codes.forEach(function (code) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dd-slot__code';
      btn.textContent = code;
      btn.addEventListener('click', function () { copyCode(btn, code); });
      codesEl.appendChild(btn);
    });

    // The signup response is not proof of coupon delivery. Keep the truthful
    // translated save-code guidance rendered by the snippet in every outcome.

    setState('revealed');

    if (outcome.id === 'jackpot') fireCoinShower();

    try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (e) {}
  }

  function copyCode(btn, code) {
    var done = function () {
      btn.classList.add('is-copied');
      setTimeout(function () { btn.classList.remove('is-copied'); }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(fallback);
    } else {
      fallback();
    }
    function fallback() {
      try {
        var ta = document.createElement('textarea');
        ta.value = code;
        ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        done();
      } catch (e) { /* no-op */ }
    }
  }

  // ---------- Pull lever flow ----------
  function pull() {
    if (pullBtn.disabled) return;
    if (!validateForm()) return;
    if (isInCooldown()) { showCooldown(); return; }

    var email = emailInput.value.trim();
    var outcome = pickOutcome();

    submitToShopify(email);

    resetReels(outcome.symbol);
    setState('spinning');
    root.classList.add('is-pulled');

    // Force reflow before swapping transition so the spin loop animates.
    // eslint-disable-next-line no-unused-expressions
    reelsEl.offsetWidth;

    if (prefersReducedMotion) {
      // Snap all three reels in 150ms total.
      reels.forEach(function (reel, i) { landReel(reel, i * 30); });
      setTimeout(function () { reveal(outcome, email); }, 200);
      return;
    }

    // Sequential landings, 600ms apart, with a brief spin-up first.
    var spinUp = 800;
    reels.forEach(function (reel, i) { landReel(reel, spinUp + i * 600); });

    var totalSpin = spinUp + (reels.length - 1) * 600 + 500;
    setTimeout(function () { reveal(outcome, email); }, totalSpin);
  }

  // ---------- Wire events ----------
  toggleBtn.addEventListener('click', function () {
    if (root.classList.contains('is-open')) close(); else open();
  });
  closeBtn.addEventListener('click', close);

  emailInput.addEventListener('input', validateForm);
  consent.addEventListener('change', validateForm);

  // Block native form submit; the lever drives the flow.
  form.addEventListener('submit', function (e) { e.preventDefault(); pull(); });
  pullBtn.addEventListener('click', function (e) { e.preventDefault(); pull(); });

  // Click outside panel → close. Esc → close.
  document.addEventListener('click', function (e) {
    if (!root.classList.contains('is-open')) return;
    if (panel.contains(e.target) || toggleBtn.contains(e.target)) return;
    close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  // If cooldown is already active on first paint, the tab still shows;
  // clicking it routes through open() → showCooldown(). No work needed here.
})();
